import { createResource } from "react-resource-router";
import { getSchools } from "../../apis/School";
import { useSchoolStore } from "../../store/SchoolStore";
import { getRole } from "../../apis/Utilities";

export const schoolResource = createResource({

  type: "SCHOOLS",
  getKey: () => "schools",
  getData: async () => {

    console.log("Attempting to get resource");

    const schoolSore = SchoolStore();

    console.log("School Reosource:");

    console.log(schoolSore);

    const role = await getRole(schoolSore.schoolId)

    console.log("School Roles: ")
    console.log(role)

    schoolSore.onSelectSchool({roles: role})

    //TODO: Get more school data

  }

});



export const SchoolStore = () => {
  return useSchoolStore();
};



